import { Currency } from '@/core/currency/interfaces';

const ETB: Currency = {
    name: 'Ethiopian Birr',
    demonym: 'Ethiopian',
    majorSingle: 'Birr',
    majorPlural: 'Birr',
    codeNumeric: '230',
    symbol: 'Br',
    symbolNative: 'ብር',
    minorSingle: 'Santim',
    minorPlural: 'Santim',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ETB',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ETB;
